import { TabPanel } from "@headlessui/react";

export function TabPanelWrapper({ children }: { children: React.ReactNode }) {
  return (
    <TabPanel>
      <div className="relative mx-2 flex  flex-col gap-1 h-[calc(360px-47px)] max-h-[calc(100%-47px)] overflow-y-auto px-2 pb-2 text-gray-700">
        {children}
      </div>
    </TabPanel>
  );
}
